import axios from '@/plugins/axios.js';

export default {
    state: {
        questions: null,
        loading: false,
        errors: null,
    },

    getters: {},

    actions: {
        async preview({ commit }, form) {
            commit('TOGGLE_LOADING');

            try {
                const { data } = await axios.post('/api/quiz-preview', form, {
                    errorHandle: false,
                });

                commit('SET_PREVIEW', data.data);
            } finally {
                commit('TOGGLE_LOADING');
            }
        },

        import({ commit }, form) {
            commit('TOGGLE_LOADING');

            try {
                return axios.post('/api/quiz-import', form, {
                    errorHandle: false,
                });
            } finally {
                commit('TOGGLE_LOADING');
            }
        },

        reset({ commit }) {
            commit('SET_PREVIEW', null);
            commit('SET_ERRORS', null);
        },
    },

    mutations: {
        SET_PREVIEW(state, questions) {
            state.questions = questions;
        },

        SET_ERRORS(state, errors) {
            state.errors = errors;
        },

        TOGGLE_LOADING(state) {
            state.loading = !state.loading;
        },
    },
};
